export const TOURNAMENT_UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isTournamentUuid = (value) =>
  TOURNAMENT_UUID_REGEX.test(String(value || ""));

export const slugifyTournamentName = (value = "") => {
  const slug = String(value)
    .trim()
    .toLowerCase()
    .replace(/['\u2018\u2019]/g, "")
    .replace(/&+/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return slug || "tournament";
};

export const tournamentKey = (tournamentOrKey) => {
  if (!tournamentOrKey) return "";
  if (typeof tournamentOrKey === "string") return tournamentOrKey;
  return tournamentOrKey.slug || tournamentOrKey.id || "";
};

export const tournamentPath = (tournamentOrKey, suffix = "") => {
  const key = tournamentKey(tournamentOrKey);
  if (!key) return "/tournaments";
  const path = suffix
    ? suffix.startsWith("/")
      ? suffix
      : `/${suffix}`
    : "";
  return `/tournament/${key}${path}`;
};

export const rewriteTournamentPath = (pathname, fromKey, toKey) => {
  const prefix = `/tournament/${fromKey}`;
  if (!pathname.startsWith(prefix)) return pathname;
  const rest = pathname.slice(prefix.length);
  return `/tournament/${toKey}${rest}`;
};
